module.exports = __webpack_public_path__ + "img/昆明医科大学第二附属医院（工人医院）.57061434.png";